import { ChangeEvent, Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button, Select, MenuItem, SelectChangeEvent, CardMedia, Input } from "@mui/material";
import React from "react";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddTypeFlavor({
  open,
  onClose,
  setOpen,
}: ModalProps) {

  const [age, setAge] = React.useState('0');
  const handleChange = (event: SelectChangeEvent) => {
    setAge(event.target.value as string);
  };

  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");

  return (
    <Modal
      className="modal addType_modal"
      open={open}
      onClose={onClose}
    >
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Add Flavor</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
              aria-label="Close"
            >
              <CloseIcon />
            </button>
          </div>

          <form className="form" action="">
            <div className="gap_p">
              <div className="control_group w_50">
                <label htmlFor="icon-button-file">
                  Upload Flavor Image<span className="req">*</span>
                </label>
                {image ? (
                  <div className="upload_image">
                    <div className="upload_image_holder no_radius v2">
                      <figure>
                        <CardMedia component="img" image={image} alt="photo" />
                      </figure>
                      <CloseIcon
                        onClick={() => {
                          setImage("");
                          setFileName("");
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <label className="upload_image" htmlFor="icon-button-file">
                    <Input
                      sx={{ display: "none" }}
                      id="icon-button-file"
                      type="file"
                      inputProps={{ accept: "image/png,image/jpeg" }}
                      onChange={(event: ChangeEvent<HTMLInputElement>) => {
                        const files = event.target.files;
                        if (files && files[0].type.includes("image")) {
                          setFileName(files[0].name);
                          setImage(URL.createObjectURL(files[0]));
                        }
                      }}
                    />
                    <span className="upload_image_holder no_radius">
                      <figure className="add_img">
                        <img src="/static/images/placeholder.png" alt="icon" />
                        <span className="upload_img_icon">
                          <img src="/static/images/edit2_icon.svg" alt="icon" />
                        </span>
                      </figure>
                    </span>
                  </label>
                )}
              </div>
              <div className="control_group">
                <label htmlFor="type-flavor">Select Flavor</label>
                <Select
                  fullWidth
                  hiddenLabel
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={age}
                  onChange={handleChange}
                >
                  <MenuItem value={0} disabled>Choose a flavor</MenuItem>
                  <MenuItem value={10}>Flavor 1</MenuItem>
                  <MenuItem value={20}>Flavor 2</MenuItem>
                  <MenuItem value={30}>Flavor 3</MenuItem>
                </Select>
              </div>

              <div className="control_group">
                <label htmlFor="reject-reason">Price per 100g (OMR)</label>
                <TextField fullWidth hiddenLabel placeholder="0.00" type="number" />
              </div>

              <div className="control_group w_33">
                <label htmlFor="reject-reason">Small Size Price (OMR)</label>
                <TextField fullWidth hiddenLabel placeholder="0.00" type="number" />
              </div>

              <div className="control_group w_33">
                <label htmlFor="reject-reason">Medium Size Price (OMR)</label>
                <TextField fullWidth hiddenLabel placeholder="0.00" type="number" />
              </div>

              <div className="control_group w_33">
                <label htmlFor="reject-reason">Large Size Price (OMR)</label>
                <TextField fullWidth hiddenLabel placeholder="0.00" type="number" />
              </div>
            </div>

            <div className="footer_btn_flex">
              <Button
                className="btn btn_primary"
                onClick={() => setOpen(false)}
              >
                Add Flavor
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
